export default __webpack_public_path__ + "static/media/password.6a6de797.svg";